<template>
  <BaseForm
    :title="formTitle"
    :formData="producerAreaData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    producerAreaId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      producerAreaData: {
        name: ''
      },
      fields: [
        { model: 'name', label: 'Area Name', required: true, type: 'text' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.producerAreaId ? `Edit Producer Area` : 'Add Producer Area';
    },
    submitUrl() {
      return this.producerAreaId ? `/api/v1/producer_area/producer-areas/${this.producerAreaId}/` : '/api/v1/producer_area/producer-areas/';
    },
    method() {
      return this.producerAreaId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.producerAreaId) {
      this.loadProducerAreaData();
    }
  },
  methods: {
    loadProducerAreaData() {
      axios.get(`/api/v1/producer_area/producer-areas/${this.producerAreaId}/`).then(response => {
        this.producerAreaData = response.data;
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Producer Area saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the producer area!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
